import {LIMPAR_ULTIMOS_HISTORICOS_PASSAGEIRO} from '../types';

export default function limparUltimosHistoricosPassageiro () {
    return {
        type: LIMPAR_ULTIMOS_HISTORICOS_PASSAGEIRO
    }
}
